

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Elements from "./Elements.js"
import Section from 'grommet/components/Section';
//import Tiles from 'grommet/components/Tiles';
//import Tile from 'grommet/components/Tile';
//import Button from 'grommet/components/Button';
import Box from 'grommet/components/Box';
//import Headline from 'grommet/components/Headline';
//import Heading from 'grommet/components/Heading';
import Paragraph from 'grommet/components/Paragraph';

//import Anchor from 'grommet/components/Anchor';
//import Video from 'grommet/components/Video';
import Layer from 'grommet/components/Layer';
//import history from '../RouteHistory';
import Article from 'grommet/components/Article';
//import AnnotatedMeter from 'grommet-addons/components/AnnotatedMeter';
import Button from 'grommet/components/Button';
import Headline from 'grommet/components/Headline';
import Label from 'grommet/components/Label';
import DownIcon from 'grommet/components/icons/base/Down';

import {charts, statisticsFitModel, statisticsExplore, statisticsDataSource} from "../data/Data.js"

import Tabletop from "../samples/data/Tabletop.js"

const urlViews = "https://docs.google.com/spreadsheets/d/1uvY9b1VTyfpCHLvPjc4DhUSSnZoKUGlxQ7j8W7eSNRE/edit?usp=sharing";
export default class Home extends Component {
  contextTypes() {
    router: PropTypes.object
  }
  constructor (props) {
    super(props);
    this._onOpen = this._onOpen.bind(this);
    this._onClose = this._onClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmit9 = this.handleSubmit9.bind(this);
    this._onClickOptions = this._onClickOptions.bind(this);
    this._onCloseOptions = this._onCloseOptions.bind(this);
    this._onSelectStatisticsFitModel = this._onSelectStatisticsFitModel.bind(this);
    //this._onSelectCharts = this._onSelectCharts.bind(this);
    //this._onSelectStatisticsExplore = this._onSelectStatisticsExplore.bind(this);
    //this._onSelectStatisticsDataSource = this._onSelectStatisticsDataSource.bind(this);
    this._onClickDataSource = this._onClickDataSource.bind(this);

    this.state = { 
      layerActive: false, 
      optionsLayer: false, 
      currentElement: "",
      currentLayer: "",
      optionsContent: null,
      runContent: null,
      dataObject: null,
      positionFilter: [],
      dataNames: {},
      optionsObject: null,

      dataready: false,
      validateready: false,
      outliersready: false,
      distready: false,
      multicorrready: false,
      selectready: false,
      runsready: false,

      length: 0,
      rows: 0,
      descriptionElement: "",
      linkElement: "",
      dataSplit: "",
      
      predictData: null,
      urlPredict: null,
      searchParam: false
    };
  }
  componentDidMount() {
    const searchParam = window.location.search
    if (searchParam) this.getView(urlViews, searchParam)
  }
  getView(url, searchParam) {
    //const id = window.location.search
    this.setState({spinningFlag: true, searchParam: true}) 
    const that = this;
    //Search for the term to look for the sheet
    Tabletop.init({ key: url, //publicSpreadsheetUrl,
        callback: showInfo,
        simpleSheet: false,
        parseNumbers: true
    })
    let Arrayarray = [];
    function showInfo(data, tabletop) {
        console.log('Successfully processed!')
        let foundit = 0;
        //.sheets(name) is how you access a specific sheet. Say I have a worksheet called Cats I Know, I'll access it via tabletop.sheets("Cats I Know")
        const parameterUrl = searchParam.split("=")[1]
        if (parameterUrl && data[`Copy of ${parameterUrl}`] && data[`Copy of ${parameterUrl}`].elements) {
          const dataSheet = data[`Copy of ${parameterUrl}`].elements

          const rows = dataSheet.length;
          const keys = Object.keys(dataSheet[0])
          const lengthKeys = keys.length;
          
          for (let i = 0; i < lengthKeys; i++) {
              let tempArray = []
              dataSheet.forEach((ele, index)=>{
                  tempArray.push(ele[keys[i]])
              })
              Arrayarray.push(tempArray)
          }

          console.log(Arrayarray)

          let dataNamesObj = {}
          keys.forEach((ele, index)=>{
              dataNamesObj[`positionname${index + 1}`] = ele
          })

          that._onSelectStatisticsFitModel(0);
          that._onSubmit("source", Arrayarray, "80%-20%", rows, [], null, dataNamesObj)
          //that.setState({showcomponent: true, predictData: Arrayarray, model: modelParsed, alertNull: false, spinningFlag: false})
          /* data.forEach((ele, index)=>{
              if (`?id=${ele.id}` === searchParam) {
                  foundit = 1
                  that.queryGoogle(ele.url, ele.model)
              }
          }) */
          //Setstate data
          //if (!foundit) that.setState({text: "No Email Found. Re-enter your email and try again", spinningFlag: false})
        } 
    }
}
queryGoogle(url, model) {
    const modelParsed = (model) ?  JSON.parse(model) : []
    const that = this;
    Tabletop.init({ key: url, //publicSpreadsheetUrl,
        callback: showInfo,
        simpleSheet: true,
        parseNumbers: true
    })
    let Arrayarray = [];
    function showInfo(data, tabletop) {
        console.log('Successfully processed!')
        const rows = data.length;
        const keys = Object.keys(data[0])
        const lengthKeys = keys.length;
         
        for (let i = 0; i < lengthKeys; i++) {
            let tempArray = []
            data.forEach((ele, index)=>{
                tempArray.push(ele[keys[i]])
            })
            Arrayarray.push(tempArray)
        }
        that.setState({showcomponent: true, predictData: Arrayarray, model: modelParsed, alertNull: false, spinningFlag: false})
    }
    this.setState({showcomponent: false})
}

  /* componentDidUpdate() {
    //grommetux-box grommetux-box--direction-row grommetux-box--justify-between grommetux-box--align-center grommetux-box--pad-between-small
   const elements = document.querySelectorAll(".grommetux-box.grommetux-box--direction-row.grommetux-box--justify-between.grommetux-box--align-center.grommetux-box--pad-between-small");
   Array.from(elements).forEeach((input, index)=>{
     console.log(elements.childNodes)
   })
  } */
 /*  _onSelectStatisticsDataSource(event) {
    if (this.state.currentElement === statisticsDataSource[event].name) {
      this.setState({
        layerActive: true, 
        currentElement: statisticsDataSource[event].name,
        descriptionElement: statisticsDataSource[event].descriptionElement,
        linkElement: statisticsDataSource[event].linkElement,
        optionsContent: statisticsDataSource[event].optionsContent,
        dataContent: statisticsDataSource[event].dataOptions,
        runContent: statisticsDataSource[event].runOptions
      });
    } else {
      this.setState({
        layerActive: true, 
        currentElement: statisticsDataSource[event].name,
        descriptionElement: statisticsDataSource[event].descriptionElement,
        linkElement: statisticsDataSource[event].linkElement,
        optionsContent: statisticsDataSource[event].optionsContent,
        dataContent: statisticsDataSource[event].dataOptions,
        runContent: statisticsDataSource[event].runOptions,
        dataready: false,
        optionsread: false,
        //dataObject: null
      });
    }
    
  } */
  _onSelectStatisticsFitModel(event) {

    if (this.state.currentElement === statisticsFitModel[event].name) {
      this.setState({
        optionsLayer: true,
        layerActive: true,
        currentLayer: "source",
        currentElement: statisticsFitModel[event].name,
        descriptionElement: statisticsFitModel[event].descriptionElement,
        linkElement: statisticsFitModel[event].linkElement,
        optionsContent: statisticsFitModel[event].optionsContent,
        dataSource: statisticsFitModel[event].dataSource,
        dataValidate: statisticsFitModel[event].dataValidate,
        dataOutliers: statisticsFitModel[event].dataOutliers,
        dataDist: statisticsFitModel[event].dataDist,
        dataMultiCorr: statisticsFitModel[event].dataMultiCorr,
        dataContent: statisticsFitModel[event].dataOptions,
        dataExplore: statisticsFitModel[event].dataExplore,
        runContent: statisticsFitModel[event].runOptions,

      });
    } else {
      this.setState({
        optionsLayer: true,
        layerActive: true,
        currentLayer: "source",
        currentElement: statisticsFitModel[event].name,
        descriptionElement: statisticsFitModel[event].descriptionElement,
        linkElement: statisticsFitModel[event].linkElement,
        optionsContent: statisticsFitModel[event].optionsContent,
        dataSource: statisticsFitModel[event].dataSource,
        dataValidate: statisticsFitModel[event].dataValidate,
        dataOutliers: statisticsFitModel[event].dataOutliers,
        dataDist: statisticsFitModel[event].dataDist,
        dataMultiCorr: statisticsFitModel[event].dataMultiCorr,
        dataContent: statisticsFitModel[event].dataOptions,
        dataExplore: statisticsFitModel[event].dataExplore,
        runContent: statisticsFitModel[event].runOptions,
        dataready: false,
        validateready: false,
        distready: false,
        multicorrready: false,
        outliersready: false,
        selectready: false,
        runsready: false,
        //dataObject: null
      });
    }
    
  }
/*   _onSelectStatisticsExplore(event) {

    if (this.state.currentElement === statisticsExplore[event].name) {
      this.setState({
        layerActive: true, 
        currentElement: statisticsExplore[event].name,
        descriptionElement: statisticsExplore[event].descriptionElement,
        linkElement: statisticsExplore[event].linkElement,
        optionsContent: statisticsExplore[event].optionsContent,
        dataContent: statisticsExplore[event].dataOptions,
        runContenty: statisticsExplore[event].runOptions,
      });
    } else {
      this.setState({
        layerActive: true, 
        currentElement: statisticsExplore[event].name,
        descriptionElement: statisticsExplore[event].descriptionElement,
        linkElement: statisticsExplore[event].linkElement,
        optionsContent: statisticsExplore[event].optionsContent,
        dataContent: statisticsExplore[event].dataOptions,
        runContent: statisticsExplore[event].runOptions,
        dataready: false,
        runsready: false,
        //dataObject: null
      });
    }
  } */
/*   _onSelectCharts(event) {
    if (this.state.currentElement === statistics[event].name) {
      this.setState({
        layerActive: true, 
        currentElement: charts[event].name, 
        optionsContent: charts[event].optionsContent,
        dataContent: charts[event].dataOptions,
        runContent: charts[event].runOptions,
      });
    } else {
      this.setState({
        layerActive: true, 
        currentElement: charts[event].name, 
        optionsContent: charts[event].optionsContent,
        dataContent: charts[event].dataOptions,
        runContent: charts[event].runOptions,
        dataready: false,
        runsready: false
      });

    }
    
  } */
  _onOpen () {
    this.setState({layerActive: true});
  }
  componentDidUpdate() {
    Array.from(document.querySelectorAll(".grommetux-layer__container")).forEach((element, index)=>{
      if (element) {
        element.style.width = "100%"
        element.style.bottom = "0px";
        element.style.top = "0px";
        element.style.right = "0px";
        //element.style.maxHeight = "100%";
        element.style.maxWidth = "100%";
        element.style["-webkit-transform"] = "translate(0,0)";
        element.style["-ms-transform"] = "translate(0,0)";
        element.style.transform = "translate(0,0)";
        //element.style.height = "100%"
        //element.setAttribute("style", "width: 100%; height: 100%")
      }
    });
    Array.from(document.querySelectorAll(".grommetux-value--align-start")).forEach((ele) => {
      if (ele && ele.nextSibling && ele.parentElement) {
        ele.parentElement.removeChild(ele.nextSibling);
      }
    })
  }
  _onClose () {
    const {dataready, runsready, currentElement} = this.state;
    if (currentElement === "Data Source") {
      if (dataready && runsready) {
        this.setState({layerActive: false});
        window.scrollTo({
          top: -100,
          left: 0,
          behavior: 'smooth'
        });
      } else {
        alert("We recommend clicking on Validate and Submit. Also you can add funny names to your variables")
      }
    } else {
      this.setState({layerActive: false});
        window.scrollTo({
          top: -100,
          left: 0,
          behavior: 'smooth'
        });
    }
  }

  _onCloseOptions() {
    this.setState({optionsLayer: false});
  }

  handleSubmit(event) {
    window.open(`${event}`);
  }
  _onClickDataSource(currentElement, option, state) {
    console.log(option)
    if (state === "set") {
      this.setState({optionsLayer: true, currentLayer: option});
    } 
  }
  _onClickOptions(currentElement, option, state) {
    if (state === "set") {
      this.setState({optionsLayer: true, currentLayer: option});
    } 
  }
  handleSubmit9(y) {
    const path = `/${y}`;    
    this.context.router.push(path);
  }
  _onSubmit(one, two, length, rows, predictData, urlPredict, dataNamesObj) {
    console.log(one);
    console.log(two);
    console.log(length); 
    console.log(rows);
    console.log(predictData);
    console.log(urlPredict);
    console.log(dataNamesObj);
    const {currentElement} = this.state;
    if (one === "source" && two  && currentElement !== "Data Source") {
      this.setState({
        validateready: true,
        distready: false,
        multicorrready: false,
        outliersready: false,
        selectready: false,
        runsready: false,
        dataObject: two,
        optionsLayer: true,
        dataNames: dataNamesObj,
        dataSplit: length,
        rows: rows,
        predictData,
        urlPredict,
        currentLayer: "validate"
      })
    } else if (one === "validate"){
      this.setState({
        outliersready: true,
        dataNames: two,
        optionsLayer: true,
        length: length,
        currentLayer: "outliers"
      })
    } else if (one === "outliers"){
      this.setState({
        distready: true,
        currentLayer: "dist"
      })
    } else if (one === "dist"){
      this.setState({
        multicorrready: true,
        currentLayer: "multicorr"
      })
    } else if (one === "multicorr"){
      this.setState({
        selectready: true,
        currentLayer: "data"
      })
    } else if (one === "data" && two  && currentElement !== "Data Source") {
      this.setState({
        runsready: true,
        positionFilter: two,
        optionsLayer: true,
        currentLayer: "run"
      })
    } else if (one === "run" && currentElement !== "Data Source"){
      this.setState({
        runsready: true,
        runsready: true,
        dataNames: two,
        optionsLayer: false,
        length: length,
        layerActive: false
      })
        window.scrollTo({
          top: -100,
          left: 0,
          behavior: 'smooth'
        });
      this._onCloseOptions();
    } 
  }
  isMobileDevice() {
    console.log(typeof window.orientation !== "undefined")

    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
  }
  render() {
    
    const {
      currentElement, 
      currentLayer, 
      
      

      dataSource,
      dataValidate,
      dataOutliers,
      dataDist,
      dataMultiCorr,
      dataContent,
      optionsContent,
      runContent,

      dataObject,
      positionFilter,
      dataNames,
      optionsObject,

      validateready,
      outliersready,
      distready,
      multicorrready,
      selectready,
      runsready,

      length,
      dataSplit,
      rows,
      predictData,
      urlPredict,
      searchParam
    } = this.state;

    let optionsLayer;
    if (this.state.optionsLayer) {
      const Display = (currentLayer === "source") 
        ? dataSource : (currentLayer === "validate") 
        ? dataValidate : (currentLayer === "outliers") 
        ? dataOutliers : (currentLayer === "dist") 
        ? dataDist: (currentLayer === "multicorr") 
        ? dataMultiCorr: (currentLayer === "data") 
        ? dataContent : (currentLayer === "options") 
        ? optionsContent : (currentLayer === "run")
        ? runContent : null
        console.log(dataObject)
      optionsLayer = (
          <Box pad={{vertical: 'large'}} style={{width: "100%", height: "100%"}}>
            {(currentLayer !== "run") && 
            <Display  
              currentElement={currentElement}
              positionFilter={positionFilter}
              length = {length}
              rows = {rows}
              dataNames={dataNames}
              onSubmit={this._onSubmit.bind(this, currentLayer)}
              dataObject={dataObject}/>}
            {(currentLayer === "run") && 
            <Display  
              currentElement={currentElement} 
              onSubmit={this._onSubmit.bind(this, currentLayer)}
              positionFilter={positionFilter}
              dataObject={dataObject}
              length = {length}
              rows = {rows}
              dataSplit={dataSplit}
              dataNames={dataNames}
              optionsObject={optionsObject}
              predictData={predictData}
              urlPredict={urlPredict}
              />}    
          </Box>
      );
    }

    //let colorOptions, clickOptions; 
    /* if (dataready) {
      colorOptions = [{label: "", value: 2, colorIndex: "graph-2", onClick: this._onClickOptions.bind(this, currentElement, "options", "set")}]
      clickOptions = this._onClickOptions.bind(this, currentElement, "options", "set")
    } else {
      colorOptions = [{label: "", value: 2, colorIndex: "unset", onClick: this._onClickOptions.bind(this, currentElement, "options", "unset")}];
      clickOptions = this._onClickOptions.bind(this, currentElement, "options", "unset")
    } */

    let colorRun, colorValidate,  validateTypes, runOptions, selectOptions, colorSelect, colorDist, distOptions, colorOutliers, outliersOptions, multiCorrOptions, colorMultiCorr;

    if (validateready) {
      //colorValidate = [{label: "", value: 2, colorIndex: "graph-2", onClick: this._onClickOptions.bind(this, currentElement, "run", "set")}];
      colorValidate = {backgroundColor: "#425563", display: "inline-block",
      position: "absolute",
      width: "108px",
      height: "3px",
      marginTop: "38px"};
      validateTypes = this._onClickOptions.bind(this, currentElement, "validate", "set");
    } else {
      //colorValidate = [{label: "", value: 2, colorIndex: "unset", onClick: this._onClickOptions.bind(this, currentElement, "run", "unset")}];
      colorValidate = {backgroundColor: "#ddd", display: "inline-block",
      position: "absolute",
      width: "108px",
      height: "3px",
      marginTop: "38px"};
      validateTypes = this._onClickOptions.bind(this, currentElement, "validate", "unset");
    }

    if (outliersready) {
      //colorOutliers = [{label: "", value: 3, colorIndex: "graph-2", onClick: this._onClickOptions.bind(this, currentElement, "run", "set")}];
      colorOutliers = {backgroundColor: "#425563", display: "inline-block",
      position: "absolute",
      width: "108px",
      height: "3px",
      marginTop: "38px"};
      outliersOptions = this._onClickOptions.bind(this, currentElement, "outliers", "set");
    } else {
      //colorOutliers = [{label: "", value: 3, colorIndex: "unset", onClick: this._onClickOptions.bind(this, currentElement, "run", "unset")}];
      colorOutliers = {backgroundColor: "#ddd", display: "inline-block",
      position: "absolute",
      width: "108px",
      height: "3px",
      marginTop: "38px"};
      outliersOptions = this._onClickOptions.bind(this, currentElement, "outliers", "unset");
    }

    if (distready) {
      //colorDist = [{label: "", value: 4, colorIndex: "graph-2", onClick: this._onClickOptions.bind(this, currentElement, "run", "set")}];
      colorDist = {backgroundColor: "#425563", display: "inline-block",
      position: "absolute",
      width: "108px",
      height: "3px",
      marginTop: "38px"};
      distOptions = this._onClickOptions.bind(this, currentElement, "dist", "set");
    } else {
      //colorDist = [{label: "", value: 4, colorIndex: "unset", onClick: this._onClickOptions.bind(this, currentElement, "run", "unset")}];
      colorDist = {backgroundColor: "#ddd", display: "inline-block",
      position: "absolute",
      width: "108px",
      height: "3px",
      marginTop: "38px"};
      distOptions = this._onClickOptions.bind(this, currentElement, "dist", "unset");
    }

    if (multicorrready) {
      //colorMultiCorr = [{label: "", value: 5, colorIndex: "graph-2", onClick: this._onClickOptions.bind(this, currentElement, "run", "set")}];
      colorMultiCorr = {backgroundColor: "#425563", display: "inline-block",
      position: "absolute",
      width: "108px",
      height: "3px",
      marginTop: "38px"};
      multiCorrOptions = this._onClickOptions.bind(this, currentElement, "multicorr", "set");
    } else {
      //colorMultiCorr = [{label: "", value: 5, colorIndex: "unset", onClick: this._onClickOptions.bind(this, currentElement, "run", "unset")}];
      colorMultiCorr = {backgroundColor: "#ddd", display: "inline-block",
      position: "absolute",
      width: "108px",
      height: "3px",
      marginTop: "38px"};
      multiCorrOptions = this._onClickOptions.bind(this, currentElement, "multicorr", "unset");
    }

    if (selectready) {
      //colorSelect = [{label: "", value: 6, colorIndex: "graph-2", onClick: this._onClickOptions.bind(this, currentElement, "run", "set")}];
      colorSelect = {backgroundColor: "#425563", display: "inline-block",
      position: "absolute",
      width: "108px",
      height: "3px",
      marginTop: "38px"};
      selectOptions = this._onClickOptions.bind(this, currentElement, "data", "set");
    } else {
      //colorSelect = [{label: "", value: 6, colorIndex: "unset", onClick: this._onClickOptions.bind(this, currentElement, "run", "unset")}];
      colorSelect = {backgroundColor: "#ddd", display: "inline-block",
      position: "absolute",
      width: "108px",
      height: "3px",
      marginTop: "38px"};
      selectOptions = this._onClickOptions.bind(this, currentElement, "data", "unset");
    }

    if (runsready) {
      //colorRun = [{label: "", value: 7, colorIndex: "graph-2", onClick: this._onClickOptions.bind(this, currentElement, "run", "set")}];
      colorRun = {backgroundColor: "#425563", display: "inline-block",
      position: "absolute",
      width: "108px",
      height: "3px",
      marginTop: "38px"};
      runOptions = this._onClickOptions.bind(this, currentElement, "run", "set");
    } else {
      //colorRun = [{label: "", value: 7, colorIndex: "unset", onClick: this._onClickOptions.bind(this, currentElement, "run", "unset")}];
      colorRun =  {backgroundColor: "#ddd", display: "inline-block",
      position: "absolute",
      width: "108px",
      height: "3px",
      marginTop: "38px"};
      runOptions = this._onClickOptions.bind(this, currentElement, "run", "unset");
    }
    
    let dialogLayer;
    let dataObjectNull = true
    if (dataObject) {
      dataObjectNull = false
    };
    const container = {
      display: "flex", 
      width: "100%", 
      flexWrap: "wrap", 
      justifyContent: "center",
      paddingTop: "20px",
      paddingBottom: "9px"
    }
    const element = {
      display: "flex", 
      marginRight: "10px", 
      paddingLeft: "5px", 
      paddingTop: "5px",
      width: "108px",
      cursor: "pointer"
    }
    const number = {
      display: "inline-block",
      fontWeight: "600",
      fontSize: "20px",
      marginTop: "2px"
    }
    
    const text = {
      display: "inline-block",
      paddingLeft: "5px",
      paddingTop: "9px",
      fontSize: "14px",
      fontWeight: "300",
      letterSpacing: "0.9px",
      color: "#58585b"
    }
    const circle = {
      display: "inline-block",
      position: "absolute",
      width: "108px",
      height: "3px",
      marginTop: "38px",
      backgroundColor: "#425563"
    }
    if (this.state.layerActive) {
      dialogLayer = (
        <Layer onClose={this._onClose} closer={true} align="center" flush={true} style={{top: "0px", bottom: "0px", maxHeight: "100%"}}>
        <div style={{width: "100%", height: "100%"}}>
        <div style={container}>
            {!searchParam && <div style={element} onClick={this._onClickDataSource.bind(this, currentElement, "source", "set")}>
              <div style={number}>1</div>
              <div style={text}>Source</div>
              <div style={circle}></div>
            </div>}
            <div style={element} onClick={validateTypes}>
              <div style={number}>2</div>
              <div style={text}>Types</div>
              <div style={colorValidate}></div>
            </div>
            <div style={element} onClick={outliersOptions}>
              <div style={number}>3</div>
              <div style={text}>Outlier</div>
              <div style={colorOutliers}></div>
            </div>
            <div style={element} onClick={distOptions}>
              <div style={number}>4</div>
              <div style={text}>Distribution</div>
              <div style={colorDist}></div>
            </div>
            <div style={element} onClick={multiCorrOptions}>
              <div style={number}>5</div>
              <div style={text}>Correlations</div>
              <div style={colorMultiCorr}></div>
            </div>
            <div style={element} onClick={selectOptions}>
              <div style={number}>6</div>
              <div style={text}>Qualitative</div>
              <div style={colorSelect}></div>
            </div>
            <div style={element}>
              <div style={number}>7</div>
              <div style={text}>Descriptive</div>
              <div style={colorRun}></div>
            </div>
          </div>
        <div>
            {/*!this.isMobileDevice() && <Box direction='row'
                        justify='center'
                        align='center'
                        wrap={false}
                        reverse={false}
                        margin='none'
                       >
                        <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            <div style={{width: "50px", marginRight: "50px", cursor: "pointer"}} onClick={this._onClickDataSource.bind(this, currentElement, "source", "set")}>
                              <AnnotatedMeter
                                legend={false}
                                size='small'
                                type='bar'
                                max={1}
                                series={[{label: "", value: 1, colorIndex: "graph-1"}]}
                                />
                                <text>Data Source</text>
                              </div>
                            </Box>
                          <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            <div style={{width: "50px", marginRight: "50px", cursor: "pointer"}} onClick={validateTypes}>
                              <AnnotatedMeter
                                legend={false}
                                size='small'
                                type='bar'
                                max={2}
                                series={colorValidate}
                                /> 
                                <text>Validate Types</text>
                              </div>
                            </Box>
                            <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            <div style={{width: "50px", marginRight: "50px", cursor: "pointer"}} onClick={outliersOptions}>
                              <AnnotatedMeter
                                legend={false}
                                size='small'
                                type='bar'
                                max={3}
                                series={colorOutliers}
                                /> 
                                <text>Validate Outliers</text>
                              </div>
                            </Box>
                            <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            <div style={{width: "50px", marginRight: "50px", cursor: "pointer"}} onClick={distOptions}>
                              <AnnotatedMeter
                                legend={false}
                                size='small'
                                type='bar'
                                max={4}
                                series={colorDist}
                                /> 
                                <text>Validate Distribution</text>
                              </div>
                            </Box>
                            <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            <div style={{width: "50px", marginRight: "50px", cursor: "pointer"}} onClick={multiCorrOptions}>
                              <AnnotatedMeter
                                legend={false}
                                size='small'
                                type='bar'
                                max={4}
                                series={colorMultiCorr}
                                /> 
                                <text>Validate Correlations</text>
                              </div>
                            </Box>
                            <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            <div style={{width: "50px", marginRight: "50px", cursor: "pointer"}} onClick={selectOptions}>
                              <AnnotatedMeter
                                legend={false}
                                size='small'
                                type='bar'
                                max={5}
                                series={colorSelect}
                                />
                                <text>Validate Qualitative</text>
                              </div>
                            </Box>
                            
                            <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            <div style={{width: "50px", marginRight: "50px", cursor: "pointer"}} onClick={runOptions}>
                              <AnnotatedMeter
                                legend={false}
                                size='small'
                                type='bar'
                                max={6}
                                series={colorRun}
                                />
                                <text>Descriptive Statistics</text>
                              </div>
                            </Box>
      </Box>  */} 
            </div>
            <div style={{position: "relative", height: "calc(100vh - 170px)"}}>
                <div style={{height: "100%", overflowY: "auto"}}>
                  <Box pad={{vertical: 'none'}} style={{width: "100%", height: "100%"}}>
                    {/* <h2><strong>Get Started</strong></h2>
                    <Paragraph>
                      {descriptionElement} &nbsp; <a target={"_blank"} href={linkElement}>{linkElement}</a>
                    </Paragraph> */}
                    <div style={{padding: "0px 30px"}}>
                      {optionsLayer}
                    </div>
                    
                  </Box>
                </div>
            </div>
        </div> 
        </Layer>
      );
    }


    
    return (
      <Article className="home" scrollStep={false}>

<div>
	    <Box>
          <Section appCentered={true} pad="none" className="home__section"
             style={{ "background-image": "url('background3.jpg')"}}  colorIndex="dark"
            primary={true} full={true} justify="end" align="center" > 
            

            <Box
              pad={{horizontal: 'large', vertical: 'large', between: 'medium'}}
              full="horizontal" align="center"
              className="home__welcome"
			  colorIndex="light-2"
              style={{ opacity: '0.8'}}>
              {/* <Search ref="search" inline={true} responsive={false} fill={true}
            size="huge" placeHolder="Search"
            defaultValue={"search.text"} onDOMChange={this._onSearchChange}
            onSelect={this._onSearchSelect}
            suggestions={this.state.suggestions}/><br/><br/><br/> */}
			 
              <Headline size="small" strong={true} align="center" margin="none"><font size="20">
                In-browser Data Preparation Tool<br/></font>
                <Paragraph>
                  <b>
                  <Label>Evaluate assumptions in record time and no code required!</Label> <br/> 
                  </b>

                </Paragraph>
                <Label style={{fontSize: "12px"}}>Want to read the blog behind this? <a href="https://medium.com/@Fredy_Gomez_J/data-cleansing-and-preparation-for-machine-learning-statistic-models-fb3e84606762?sk=a972fac2e036d1ca18aeadbb1d881fe0" target="_blank" >Click here</a></Label>
              </Headline>
			  {/*
			  <Paragraph size="large" align="center" margin="none">
                <b>text here</b><br/><br/><br/></Paragraph>
			  
              <Heading align="start" tag="h4">
                <li style={{fontSize: "120%"}}>No need of setting up anything or learn a new lenguages</li>
                <li style={{fontSize: "120%"}}>All data-processing happens in the browser</li> 
                <li style={{fontSize: "120%"}}>Two modes: UI (Use workflows) or Live Edit (Code in Javascript)</li>	
              </Heading> */}
				 
         <Elements
          dataObjectNull={dataObjectNull}
          statisticsExplore={statisticsExplore} 
          statisticsFitModel={statisticsFitModel}
          statisticsDataSource={statisticsDataSource}
          onSelectStatisticsDataSource={this._onSelectStatisticsDataSource}
          onSelectStatisticsExplore={this._onSelectStatisticsExplore} 
          onSelectStatisticsFitModel={this._onSelectStatisticsFitModel}/>
                 <a href="#section2"><DownIcon size="large" colorIndex="light-1" style={{cursor: "pointer"}} /></a><br/><br/><br/>
			</Box>		
          </Section>
		 <Section align="start" pad={{"horizontal": "medium", "vertical": "medium", "between": "small"}} >	  
     {/* <h2 id="section2">Use Cases</h2>
			<Tiles fill={true} flush={false}>
				<Tile colorIndex="light-1">
          <div style={{paddingTop: "80px"}}>
          <Anchor target={"_blank"} href='https://medium.com/@Fredy_Gomez_J/in-browser-machine-learning-google-sheets-prophesier-6ebc5be300a4'>
            <Card thumbnail='/img/anomaly.png'
              label='Anomaly Analysis for a Time Serie dataset'
              />
          </Anchor>
          </div>
				</Tile>
        <Tile colorIndex="light-1">
          <div style={{paddingTop: "80px"}}>
          <Anchor target={"_blank"} href='https://medium.com/@Fredy_Gomez_J/in-browser-machine-learning-predict-house-prices-using-google-sheets-and-prophesier-ca4547633f66'>
            <Card thumbnail='/img/linearregression.png'
              label='Predict House Prices using Multi linear regression'
              />
          </Anchor>
          </div>
				</Tile>
			  </Tiles>		   */}
		</Section> 
       
        </Box>
	</div>
        
      {dialogLayer}
      </Article>
	  );
  }
};
Home.contextTypes = {
  router: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/Workflow.js